export default __webpack_public_path__ + "0541c28460ea021e8044d163abbb22f2.png";